"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
exports.piRadians = numberMeasure_1.Measure.of(Math.PI, base_1.radians, "pi rad");
exports.tauRadians = numberMeasure_1.Measure.of(2, exports.piRadians, "tau rad");
exports.degrees = numberMeasure_1.Measure.of(1 / 180, exports.piRadians, "deg");
exports.arcMinutes = numberMeasure_1.Measure.of(1 / 60, exports.degrees, "arcmin");
exports.arcSeconds = numberMeasure_1.Measure.of(1 / 60, exports.arcMinutes, "arcsec");
//# sourceMappingURL=angle.js.map